var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"customer-stats"},[_c('StatChange',{staticClass:"stat-change",attrs:{"title":"Kundens ordrer i alt","value":_vm.stats.totalOrders,"changeTitle":"Seneste 30 dage","changeValue":_vm.stats.totalOrdersLastMonth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }